export const GET_COUNTRY_PARAMETER = 'GET_COUNTRY_PARAMETER';
export const GET_SONG_ID_PARAMETER = 'GET_SONG_ID_PARAMETER';